
import { repository } from 'src/jtech/jtech-repository'

export const ServiceRequestRepository = {

  nmInterfaceSigreValuesToCompensateForm: 'sigre.valuesToCompensateForm',

  loadValuesToCompensateForm: async function () {
    return await repository.resolve(this.nmInterfaceSigreValuesToCompensateForm)
  }

}
